
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liked/products",
      function () {
        return require("private-next-pages/liked/products.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/liked/products"])
      });
    }
  